const SET_IS_SHOWING_HOW_SPONSORSHIPS_WORKS_MODAL =
  'supportersScreen/SET_IS_SHOWING_HOW_SPONSORSHIPS_WORKS_MODAL';

export default {
  SET_IS_SHOWING_HOW_SPONSORSHIPS_WORKS_MODAL,
};
